"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getDay = function getDay(date) {
  return (0, _dayjs["default"])(date).date();
};

var _default = getDay;
exports["default"] = _default;